<template>
  <CustomPage title="地址列表" right-text="新增地址" @onClickRight="onCreate">
    <div slot="content" class="address-container">
      <div
        class="panel"
        v-for="item in list"
        :key="item.id"
        @click="toDetail(item)"
      >
        <div class="left">
          <div class="icon">
            <Icon name="wap-home" color="#fff" v-if="item.defaultFlag" />
            <span v-else>{{ item.name.substr(0, 1) }}</span>
          </div>
          <div class="text">
            <div class="text-top">
              <span class="name">{{ item.name }}</span>
              <span class="phone">{{ item.phone }}</span>
            </div>
            <div class="text-bottom">
              {{ item.areaName }}
            </div>
          </div>
        </div>
        <div class="arr">
          <img :src="require('@/assets/setting/箭头.svg')" alt="" />
        </div>
      </div>
      <CustomView />
    </div>
  </CustomPage>
</template>

<script>
import Bus from "@/utils/bus";
import CustomView from "@/components/custom-view.vue";
import CustomPage from "@/components/custom-page.vue";
import { areaList } from "@vant/area-data";
import { getAddressList } from "@/api/setting/address";
import { Icon } from "vant";
export default {
  components: { CustomView, CustomPage, Icon },
  created() {
    this.getData();
    Bus.$on("refreshData", this.getData);
  },
  data() {
    return {
      areaList,
      list: [],
    };
  },
  methods: {
    getData() {
      getAddressList(this.$store.state.user.customerId).then((res) => {
        this.list = res.data.map((item) => {
          const province = this.areaList.province_list[item.province];
          const city = this.areaList.city_list[item.city];
          const county = this.areaList.county_list[item.area];
          item.areaName = `${province} ${city} ${county} ${item.address}`;
          return item;
        });
      });
    },
    onCreate() {
      this.$router.push({ name: "SettingAddressCreate" });
    },
    toDetail(data) {
      this.$router.push({
        name: "SettingAddressCreate",
        query: { data: JSON.stringify(data) },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.address-container {
  padding: 22px 24px;
  .panel {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0px 4px 12px 0px rgba(153, 153, 153, 0.1);
    border-radius: 12px;
    margin-bottom: 20px;
    padding: 20px;
    .left {
      display: flex;
      flex: 1;
      min-width: 0;
    }
    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 44px;
      height: 44px;
      background: linear-gradient(135deg, #e82035 0%, #ff9600 100%);
      font-size: 26px;
      line-height: 44px;
      border-radius: 100%;
      margin-right: 20px;
      color: #fff;
    }
    .text {
      flex: 1;
      min-width: 0;
      .text-top {
        font-size: 32px;
        line-height: 1em;
        .phone {
          margin-left: 20px;
        }
      }
      .text-bottom {
        color: #999999;
        font-size: 28px;
        line-height: 36px;
        padding-top: 12px;
      }
    }
  }
}
</style>